import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import BottomModal from '../../components/modal/BottomModal';

type Props = {
  title: string;
  content: string;
};

export default function InfoTooltip({ title, content }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <Wrap>
      <IconButton
        aria-label={`${title} 안내`}
        onClick={() => setOpen((v) => !v)}
      >
        <img src="/assets/images/icon/quastionmark.svg" alt="" />
      </IconButton>

      {open && (
        <BottomModal onClose={() => setOpen(false)}>
          <ModalHeader>
            <ModalTitle>{title}</ModalTitle>
            <Close onClick={() => setOpen(false)}>
              <img src="/assets/images/close/close-black.svg" alt="close" />
            </Close>
          </ModalHeader>
          <Body>{content}</Body>
          <Bottom onClick={() => setOpen(false)}>
            <BottomButton>확인</BottomButton>
          </Bottom>
        </BottomModal>
      )}
    </Wrap>
  );
}

const Wrap = styled.div`
  position: relative;
  display: inline-flex;
  justify-content: center;
  flex-direction: row;
`;

const IconButton = styled.button`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  border: none;
  outline: none;
  background-color: transparent;
  padding: 0;
  img {
    width: 20px;
    height: 20px;
  }
  &:focus-visible {
    outline: 2px solid #b9c1ff;
    border-radius: 4px;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  padding: 24px 20px 8px 20px;
  align-items: center;
  align-self: stretch;
`;

const ModalTitle = styled.div`
  flex: 1 0 0;
  color: var(--npl-semantic-label-solid-light-primary, #0c0e12);

  /* npl/body/bld/XXL_18 */
  font-family: 'Spoqa Han Sans Neo';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px; /* 155.556% */
  letter-spacing: -0.36px;
`;

const Close = styled.button`
  border: none;
  outline: none;
  background-color: transparent;
  display: flex;
  width: 40px;
  height: 40px;
  padding: 8px;
  justify-content: center;
  align-items: center;

  & > img {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }
`;

const Body = styled.div`
  display: flex;
  padding: 0 20px 8px 20px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  color: var(--npl-semantic-label-solid-light-tertiary, #787d87);

  /* npl/body/med/M_14 */
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  letter-spacing: -0.28px;
`;

const Bottom = styled.div`
  display: flex;
  width: 100%;
  padding: 16px 24px 24px 24px;
  align-items: center;
`;

const BottomButton = styled.button`
  border: none;
  outline: none;
  display: flex;
  height: 44px;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 8px;
  background: var(--npl-semantic-background-solid-light-01, #f4f5f7);
  color: var(--npl-semantic-label-solid-light-secondary, #424854);

  /* npl/body/med/L_15 */
  font-family: 'Spoqa Han Sans Neo';
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 146.667% */
  letter-spacing: -0.3px;
`;
